goog.provide('el8.appchart.dialog.reports');

goog.require('el8.app.pageLayout');
// Commenting out due to Closure deps weirdness. Causes el8.template.appchart.dialog.reports
// to be undefined
// goog.require('el8.appchart.dialog.manualLabEntry');
goog.require('el8.appchart.layout');
// goog.require('el8.appchart.reportFeeds.feeds'); //causes circular dependency
goog.require('el8.appservice.notifier');
goog.require('el8.appshared.message');
goog.require('el8.data.reportTypes');
goog.require('el8.ptdata.reports');
goog.require('el8.template.appchart.dialog.reports');
goog.require('el8.uiwidget.NewDialog');
goog.require('el8.uiwidget.PagedTabbedNav');
goog.require('el8.util.consts');

/**
 * This is the reports dialog in the patient chart. It displays
 * each report type as a feed inside of a tab.
 *
 * Slightly unusual: we call _init directly on this dialog during chart init
 * in order to set the list of reportTypes visible for this particular chart
 * and to add the dialog HTML to the DOM, because we load all the report indexes
 * as part of initial-feeds/ on chart load, rather than waiting until the dialog opens.
 */
el8.appchart.dialog.reports = (function() {

    var tabbedNav;
    var position;
    var $elt = null;
    var tabNameToFilterState = {};

    var that = new el8.uiwidget.NewDialog({
        height: function() {
            return el8.app.pageLayout.getChartInnerHeight() - 20;
        },
        width: el8.util.consts.REPORTS_DIALOG_WIDTH,
        showXButton: true,
        // we want to be able to add this dialog to the DOM without showing it
        // so we can initialize its Feeds from initial-feeds
        openOnInit: false,
        contentFn: el8.template.appchart.dialog.reports.content
    });

    var super_init = that._init;
    that._init = function(_reportTypeIds) {
        super_init.call(that);

        _createTabbedNav(_reportTypeIds);
        that.getDialogContainer().addClass('el8CustomTitlebarBackground');
        _bindTriggers();

        // we want the list of reportTypes around so that realtime listeners
        // for deletions will work properly but we can let it load async
        el8.data.reportTypes.softLoad(null, true);
    };

    var super_adjustPosition = that.adjustPosition;
    that.adjustPosition = function() {
        // let the dialog height adjust first
        super_adjustPosition.call(that);

        // then adjust the bottom section height so the top section doesn't need to scroll
        var content = that.getContentElt();
        var totalHeight = content.height();
        var $tabSection = $('.report-tab-section', content);
        var $feedSection = $('.report-feed-section', content);
        var leftOverHeight = totalHeight - ($tabSection.outerHeight() || 0);
        $feedSection.height(leftOverHeight);

        if (position === 'left') {
            _leftJustify();
        } else if (position === 'right') {
            _rightJustify();
        } else if (el8.appchart.layout.isThirdPaneVisible()) {
            _leftJustify();
        } else {
            _rightJustify();
        }
    };

    /**
     * A naked call to show will show the first tab.
     * Otherwise, you can specify an `item`, which will open
     * the feed corresponding to that item and expand the item,
     * or a `feedName` which will open that feed.
     *
     * The reports dialog avoids overlapping with any open third pane items;
     * forcePosition allows the caller to override that default behavior,
     * e.g., if the caller is a dialog on the left that doesn't want to be covered up.
     */
    var super_show = that.show;
    that.show = function(spec) {
        spec = spec || {};
        $elt = spec.$elt && spec.$elt.length ? spec.$elt : null;

        $('.el8FeedItemNewSelected').removeClass('el8FeedItemNewSelected');
        el8.appchart.layout.showReports($elt);
        if ($elt) { $elt.addClass('el8FeedItemNewSelected'); }

        if (el8Globals['TEASE']) { $(document).trigger('show-reports-overlay'); }

        if (spec.forcePosition) { position = spec.forcePosition; }
        super_show.call(that);

        var feedName;
        if (spec.item) {
            feedName = _getFeedName(spec.item);
            tabbedNav.showTab(feedName);
            el8.appchart.reportFeeds.feeds[feedName].showItem(spec.item);
            el8.appservice.notifier.notify('Item being displayed in report feed');
        } else if (spec.feedName) {
            tabbedNav.showTab(spec.feedName);
        } else {
            tabbedNav.showTab(tabbedNav.getFirstTab());
        }
        that.adjustPosition();
    };

    var super_hide = that.hide;
    that.hide = function() {
        el8.appchart.layout.hideReports($elt);
        if ($elt) { $elt.removeClass('el8FeedItemNewSelected'); }

        super_hide.call(that);
        if (el8Globals['TEASE']) { $(document).trigger('hide-reports-overlay'); }
        position = null;
    };

    /**
     * Make sure that the feed in question either refreshes right now (if it's open)
     * or the next time it's displayed (if it's not open). Takes care of adding the
     * report type to the chart if it's not present yet.
     */
    that.ensureRefresh = function(name) {
        that.ensureFeedExists(name);
        if (_isFeedVisible(name)) {
            that.refresh(name);
        } else {
            // we're going to actually fetch the data index rather than just calling markNeedsUpdate,
            // because we will need to know which feed an Order currently lives in before displaying
            el8.appchart.reportFeeds.feeds[name].fetchDataIndex();
        }
    };
    /**
     * Determines the the list of unique report types across all the reports passed
     * in and makes sure all of them are refreshed
     */
    that.ensureRefreshAllAffected = function(reportIds) {
        if (!reportIds.length) { return; }

        var reportTypesMap = {};
        reportIds.forEach(function(reportId) {
            var report = el8.ptdata.reports.getById(reportId);
            reportTypesMap[report.getReportType()] = true;
        });
        _.keys(reportTypesMap).forEach(function(type) {
            el8.appchart.dialog.reports.ensureRefresh(type);
        });
    };
    /**
     * Make sure we have a tab and a report feed for this name
     */
    that.ensureFeedExists = function(name) {
        if (tabbedNav.getTabExists(name)) { return true; }

        var rType = el8Globals.AVAILABLE_REPORT_TYPES_BY_KEY[name];
        if (!rType) { return false; }

        _addTab(rType.id);
        el8.appchart.reportFeeds.main.addReportFeedAfterPageLoad(rType.id);
    };

    that.refresh = function(name, async, showClean) {
        if (showClean) {
            el8.appchart.reportFeeds.feeds[name].refresh({async: async});
        } else {
            el8.appchart.reportFeeds.feeds[name].update({async: async});
        }
    };
    that.refreshItem = function(item) {
        el8.appchart.reportFeeds.feeds[_getFeedName(item)].refreshItem(item);
    };

    that.clearHighlightResults = function() {
        $('.labResultHighlight', that.getDialogContainer()).removeClass('labResultHighlight');
    };

    that.writeReportMessage = function(item, rType) {
        rType = rType || item.getReportType(); // no rType is provided from the reqAct section

        el8.appshared.message.prePopulateNewMessage({
            toDocId: item.getId(),
            callbackFn: function(body, threadId) {
                // make sure the cached report knows it has a new referring message thread
                item.addThreadId(threadId);
                el8.ptdata.reports.trigger(EVENTS.UPDATED, item);
            }
        });
    };

    that.getTabNameForSubType = function(docSubType) {
        return el8Globals.AVAILABLE_REPORT_TYPES[docSubType].report_type_label.toLowerCase();
    };

    /**
     * Internal functions
     */
    function _bindTriggers() {

        that.getContentElt()
            .on('click', '.enter-poc-result-trigger',  function() {
                el8.appchart.dialog.manualLabEntry.show();
        });

        that.getContentElt()
            .on('click', '.refresh',  function() {
                if (el8Globals.FEATURES.BiDiLabs) {
                    // Reset filter state on refresh
                    $('.show-outstanding-toggle-trigger').text('Showing: All');
                    var tabName = tabbedNav.getShowingTab();
                    tabNameToFilterState[tabName] = false;
                    that.refresh(tabName, true, true);
                } else {
                    if (el8Globals['TEASE']) { return; }
                    that.refresh(tabbedNav.getShowingTab(), true, true);
                }
            });

        if (el8Globals.FEATURES.BiDiLabs) {
            // Menu
            if (!that._showOutstandingMenu) {
                that._showOutstandingMenu = new el8.uiwidget.NewActionsMenu({
                    container: $('#report-feed-dialog'),
                    anchorTop: $('#report-feed-dialog'),
                    menuId: 'report-feed-show-outstanding-menu',
                    offsets: {top: 21, left: -10},
                    width: 170
                });
            }

            // Trigger
            that.getContentElt().on('click', '.show-outstanding-toggle-trigger',  function(e) {
                // Link hidden behind BiDiLabs in template
                that._showOutstandingMenu.display(
                    $('.show-outstanding-toggle-trigger'),
                    null,
                    {top: 17, left: 10},
                    [{
                        actionText : "Show Outstanding Orders",
                        actionFn : function() {
                            // Change link text
                            $(e.target).text('Showing: Outstanding Orders');

                            // Filter the feed for outstanding orders
                            var feedIndex = el8.appchart.reportFeeds.feeds[tabbedNav.getShowingTab()].getIndex();
                            var outstandingOrderIndex = _.filter(feedIndex, function(obj) {
                                // Can't use identify here, but same logic
                                if ((obj.model_class.match('Order') !== null) &&
                                    (obj.model_class.match('MedOrder') === null)) {
                                    var eSet = el8.ptdata.getEntitySet(obj.model_class);
                                    // We get null items sometimes...
                                    var item = eSet.getById(obj.id, true);
                                    if (item && item.getCurrentState() === 'outstanding') { return true; }
                                }
                                return false;
                            });
                            var outstandingOrderIndexIds = _.pluck(outstandingOrderIndex, 'id');

                            // Invert the set
                            var indexIdsToRemove = _.pluck(_.reject(feedIndex, function(obj) {
                                return _.contains(outstandingOrderIndexIds, obj.id);
                            }), 'id');

                            // Calls removeRenderItem, also removes item from the index
                            var tabName = tabbedNav.getShowingTab();
                            _.each(indexIdsToRemove, function(id) {
                                el8.appchart.reportFeeds.feeds[tabName].remove(id);
                            });

                            tabNameToFilterState[tabName] = true;
                        }
                    },
                    {
                        actionText : "Show All",
                        actionFn : function() {
                            $(e.target).text('Showing: All');
                            var tabName = tabbedNav.getShowingTab();
                            that.refresh(tabName, false, true); // sync
                            tabNameToFilterState[tabName] = false;
                        }
                    }]
                );

                return false;
            });
        }
    }

    function _createTabbedNav(reportTypeIds) {
        tabbedNav = new el8.uiwidget.PagedTabbedNav();
        var $reportTabSection = $('.report-tab-section', that.getContentElt());
        tabbedNav.init({
            wrapper: $reportTabSection,
            pageSize: el8.util.consts.REPORT_TYPES_PER_ROW
        });

        reportTypeIds.forEach(function(rTypeId) {
            _addTab(rTypeId);
        });
    }

    function _addTab(rTypeId) {
        var $reportFeedList = $('.list-of-report-feeds', that.getDialogContainer());
        $reportFeedList.append(
            el8.template.appchart.dialog.reports.reportFeedContainer({ reportTypeId: rTypeId })
        );

        var tabLabel = el8Globals.AVAILABLE_REPORT_TYPES[rTypeId].nickname;
        // the tabName is going to be the lowercase version of the report_type_label,
        // because it matches up wit the "reportType" field on reports, so doing that makes
        // it easier to convert a Report to its connected tab name
        var tabInternalName = el8Globals.AVAILABLE_REPORT_TYPES[rTypeId].report_type_label.toLowerCase();
        var tabTooltip = el8Globals.AVAILABLE_REPORT_TYPES[rTypeId].user_label + ' Reports';

        tabNameToFilterState[tabInternalName] = false;

        tabbedNav.addTab({
            title: tabLabel,
            name: tabInternalName,
            contentDiv: $('.type-'+rTypeId+'-report-feed', that.getContentElt()),
            showTabFn: function(tabName) {
                // Reset link to filter state
                if (tabNameToFilterState[tabName]) {
                     $('.show-outstanding-toggle-trigger', that.getContentElt()).text('Showing: Outstanding Orders');
                } else {
                     $('.show-outstanding-toggle-trigger', that.getContentElt()).text('Showing: All');
                }
                el8.appchart.reportFeeds.feeds[tabName].display().scrollToTop();

                if (tabInternalName === 'lab') {
                     $('.enter-poc-result-trigger, .enter-poc-result-trigger-badge', that.getContentElt()).show();
                }
            }
        });

        el8.service.tooltip.create({
            anchor: tabbedNav.getTabElt(tabInternalName),
            text: tabTooltip,
            placement: 'top',
            showDelay: 750
        });
    }

    function _leftJustify() {
        var _top = el8.appchart.layout.getMainFeedOffsets().top + 10;
        var _left = el8.appchart.layout.getMainFeedOffsets().left + 10;
        that.getContainer().dialog("option", "position", $.ui.dialog.getPositionObject([_left, _top]));
    }
    function _rightJustify() {
        var _top = el8.appchart.layout.getMainFeedOffsets().top + 10;
        var _left = el8.app.pageLayout.getAppInnerWidth() - that.getWidth() - 10;
        that.getContainer().dialog("option", "position", $.ui.dialog.getPositionObject([_left, _top]));
    }

    function _isFeedVisible(name) {
        var visibleFeedName = tabbedNav.getShowingTab();
        return that.isOpen() && visibleFeedName && name && visibleFeedName.cmp(name);
    }

    // Helper to identify which feed is associated with a given item
    function _getFeedName(item) {
        var mClass = el8.model.idToModelClass(item.getId());
        if (mClass === 'Report') {
            return item.getReportType();

        } else if (mClass.match('Order') !== null) {
            var orderType = item.getOrderType();
            if (_.contains(['lab', 'imaging'], orderType)) {
                // these two are guaranteed to exist - their orders will always go them
                return orderType;
            }
            if (orderType === 'referral') {
                // same here, but the names don't match up
                return 'consultation';
            }
            // any other report types might end up in a custom tab, if that report type
            // is being used by the practice; they fall back to consults
            var correspondingFeed = el8.appchart.reportFeeds.feeds[orderType];
            if (correspondingFeed && correspondingFeed.hasItem(item.getId())) {
                return orderType;
            }
            return 'consultation';

        } else if (mClass === 'VisitNote' || mClass === 'NonvisitNote') {
            var docSubType = item.getDocumentSubType();
            if (!docSubType) {
                // no doc-sub-type, so we're defaulting to 'consultation'
                return 'consultation';
            }
            return that.getTabNameForSubType(docSubType);
        }
    }


    return that;

})();
